import Constant from '@/const';
import axios from 'axios';

const postCpptData = async payload => {
  try {
    const response = await axios.post(
      Constant.apiUrl.concat('/inpatient/cppt'),
      payload,
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default postCpptData;
